import { Component } from '@angular/core';

import { MenuService } from 'tms-lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(public menuService: MenuService) {}
}
